import { render, staticRenderFns } from "./ExistingMaterialViewer.vue?vue&type=template&id=cd8c4526&scoped=true"
import script from "./ExistingMaterialViewer.vue?vue&type=script&lang=js"
export * from "./ExistingMaterialViewer.vue?vue&type=script&lang=js"
import style0 from "./ExistingMaterialViewer.vue?vue&type=style&index=0&id=cd8c4526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8c4526",
  null
  
)

export default component.exports